// import { utcTimestampToTimeString } from "./index";

// Helper function to format price with precision for CDS exchange
const formatOrderPrice = (price, exchange, pricePrecision) => {
  if (!price) return Number(price);
  
  if (exchange === 'CDS' && pricePrecision !== undefined) {
    return parseFloat(parseFloat(price).toFixed(pricePrecision));
  }
  
  return Number(price);
};

export function getFormattedPendings(pending) {
  return {
    ...pending,
    time: pending.order_entry_time,
    // time: utcTimestampToTimeString(pending.order_entry_time),
    instrument_token: pending.execution_type === 'SPD' ? pending.spread_token : pending.instrument_token,
    price: formatOrderPrice(pending.price, pending.exchange, pending.price_precision),
    average_price: formatOrderPrice(pending.average_price, pending.exchange, pending.price_precision),
    trigger_price: formatOrderPrice(pending.trigger_price, pending.exchange, pending.price_precision),
    order_type: pending.order_type.replace(/[^\w\s]/gi, ""),
  };
}

export function getFormattedCompleted(complete) {
  return {
    ...complete,
    time: complete.exchange_time || complete.order_entry_time,
    // time: utcTimestampToTimeString(complete.order_entry_time),
    price: formatOrderPrice(complete.price, complete.exchange, complete.price_precision),
    average_price: formatOrderPrice(complete.average_price, complete.exchange, complete.price_precision),
    trigger_price: formatOrderPrice(complete.trigger_price, complete.exchange, complete.price_precision),
    order_type: complete.order_type.replace(/[^\w\s]/gi, ""),
  };
}

export function getFormattedTrades(trade) {
  return {
    ...trade,
    // time: utcTimestampToTimeString(trade.order_entry_time),
    time: trade.exchange_time,
    price: formatOrderPrice(trade.price, trade.exchange, trade.price_precision),
    trade_price: formatOrderPrice(trade.trade_price, trade.exchange, trade.price_precision),
    average_price: formatOrderPrice(trade.average_price, trade.exchange, trade.price_precision),
    trigger_price: formatOrderPrice(trade.trigger_price, trade.exchange, trade.price_precision),
    order_type: trade.order_type ? trade.order_type.replace(/[^\w\s]/gi, "") : "",
  };
}

export function getFormattedMarketwatches(marketwatches = []) {
  const watchlists = marketwatches.map((marketwatch) => {
    const instruments = marketwatch.instruments.map((instrument) => {
      return {
        ...instrument,
        ltp: 0,
        absoluteChange: 0,
        percentChange: 0,
        ltt: 0,
        lowDpr: 0,
        highDpr: 0,
        currentOpenInterest: 0,
        initialOpenInterest: 0,
        selectedClass: "",
      };
    });
    return { ...marketwatch, instruments };
  });

  return watchlists;
}

export function formatMarketwatchByTopGainersLosers(
  arrInstruments = [],
  arrTopGainersLosers = []
) {
  if (arrInstruments.length && arrTopGainersLosers.length) {
    const instrumentsList = arrInstruments.map((instrument) => {
      arrTopGainersLosers.forEach((gainerLoser) => {
        if (
          gainerLoser.instrument_token === instrument.token &&
          gainerLoser.exchange === instrument.exchange
        ) {
          instrument.isGainer = gainerLoser.gainer;
          instrument.isLoser = gainerLoser.loser;
        }
      });
      return instrument;
    });

    return instrumentsList;
  } else {
    return arrInstruments;
  }
}
